export enum Priority {
  IMMEDIATE = 'Immediate',
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
  PRESEASONQ3Q4 = 'PreSeasonQ3Q4',
  PRESEASONQ1Q2 = 'PreSeasonQ1Q2',
}

export enum InspoStatus {
  BUYER_REVIEW = 'Buyer Review',
  // Rejected by Buyer users
  BUYER_REVIEW_REJECTED = 'Buyer Review Rejected',
  BUYER_REQUESTED = 'Buyer Requested',
  // Rejected by PD users
  BUYER_REQUEST_REJECTED = 'Buyer Request Rejected',
  NEW_ITEM_QUOTE_NOT_REQUESTED = 'New Item Quote Not Requested',
  NEW_ITEM_QUOTE_REQUEST_SENT_TO_VENDOR = 'New Item Quote Request Sent To Vendor',
  NEW_ITEM_QUOTE_RECEIVED = 'New Item Quote Received',
  TARGET_PRICE_ADDED = 'Target Price Added',
  NEW_ITEM_QUOTE_APPROVED = 'New Item Quote Approved',
  NEW_ITEM_QUOTE_REJECTED = 'New Item Quote Rejected',
  CREATED_IN_FN_BUYER = 'Created In FN Buyer',
  PURCHASED = 'Purchased',
  ARCHIVED = 'Archived',
}
